<!-- Bottom Bar — Unified design for mobile + desktop -->
<!-- Mobile (<= 750px): full-width, no rounded corners, no AI button in bar -->
<!-- Desktop (> 750px): max-width 750px, rounded top corners, AI button in bar -->
@if (shouldShow()) {
<div class="mobile-bottom-bar-wrapper" [class.hidden]="!isVisible()" [class.sidebar-open]="isSidebarOpen()">

  <!-- Single continuous container: AddEntitiesList + Nav bar (like Flutter Column) -->
  <div class="mobile-bottom-bar" [class.add-mode]="isAddMode()">

    <!-- Add Entities List — inside the bar container for visual continuity -->
    @if(isAddMode()){
    <app-mobile-add-entities-list [class.visible]="isAddMode()" (itemSelected)="resetAddMode()"
      (clickOutside)="onClickOutside()">
    </app-mobile-add-entities-list>
    }

    <!-- Navigation items row -->
    <nav class="nav-container" role="navigation" [attr.aria-label]="ss.t('aria_mainNavigation')">
      <!-- Nav items grouped on the left -->
      <div class="nav-items-group">
        @for (item of navItems(); track item.id) {
        @if (item.id === 'today') {
        @if (isOnTodayPage()) {
        <!-- Today Plus/Close Button -->
        <div class="today-button-container">
          <button class="today-plus-button" [class.active]="isAddMode()" (click)="onTodayClick($event)"
            [attr.aria-label]="isAddMode() ? 'Close add menu' : 'Add new item'" [attr.aria-expanded]="isAddMode()">
            <!-- SVG arch shape — mobile close button background (Flutter MeBottomBar parity) -->
            @if (isAddMode()) {
            <svg class="add-shape-bg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 82 55" aria-hidden="true">
              <path d="M 0 0 L 82 0 C 72 4 66 8 66 22 L 66 47 A 8 8 0 0 1 58 55 L 24 55 A 8 8 0 0 1 16 47 L 16 22 C 16 8 10 4 0 0 Z"
                    [attr.fill]="ss.theme().color6" />
            </svg>
            }
            <div class="plus-icon-wrapper" [class.rotated]="isAddMode()">
              <app-svg name="plus" [color]="isAddMode() ? (cc.isNarrowScreen() ? ss.theme().color8 : ss.theme().color12) : (cc.isNarrowScreen() ? ss.theme().color8 : ss.theme().color35)"
                style="width: 18px; height: 18px;">
              </app-svg>
            </div>
          </button>
        </div>
        } @else {
        <!-- Today as regular nav item - shown when NOT on today page -->
        <a class="nav-item" [routerLink]="item.route" routerLinkActive="active" #rla="routerLinkActive"
          [attr.aria-current]="rla.isActive ? 'page' : null" [attr.aria-label]="item.label">
          <div class="nav-icon-container" [class.active]="rla.isActive">
            <app-svg name="radioButton" [color]="rla.isActive ? ss.theme().color12 : ss.theme().color7"
              style="width: 18px; height: 18px;">
            </app-svg>
          </div>
          <span class="nav-label" [class.active]="rla.isActive">
            {{ item.label }}
          </span>
        </a>
        }
        } @else {
        <!-- Regular navigation item -->
        <a class="nav-item" [routerLink]="item.route" routerLinkActive="active" #rla="routerLinkActive"
          [attr.aria-current]="rla.isActive ? 'page' : null" [attr.aria-label]="item.label">
          <div class="nav-icon-container" [class.active]="rla.isActive">
            <app-svg [name]="item.icon"
              [class.icon-mirror-rtl]="item.id === 'past' || item.id === 'future' || item.id === 'lists'"
              [color]="rla.isActive ? ss.theme().color12 : ss.theme().color7"
              style="width: 18px; height: 18px;">
            </app-svg>
            @if (item.id === 'messages' && !rla.isActive && unreadBadgeText()) {
              <span class="unread-badge">{{ unreadBadgeText() }}</span>
            }
          </div>
          <span class="nav-label" [class.active]="rla.isActive">
            {{ item.label }}
          </span>
        </a>
        }
        }
      </div>

      <!-- AI Button — desktop only (> 750px) -->
      @if (ss.isFeatureFlagEnabled('voice_commands')) {
        <button class="ai-fab-button" [attr.aria-label]="ss.t('aria_aiAssistant')"
          (click)="onAiFabClick()"
          appLongPress (appLongPress)="onAiFabLongPress()">
          <app-svg name="meoSparkle" [color]="ss.theme().color12"
            style="width: 24px; height: 24px;">
          </app-svg>
        </button>
      }
    </nav>

    <!-- Page-specific FABs projected here — positioned relative to the bar container -->
    <ng-content></ng-content>

    <!-- AI FAB — mobile only (<= 750px), hidden when add menu is open or on past/future pages -->
    @if (!isAddMode() && !isOnPastOrFuturePage() && ss.isFeatureFlagEnabled('voice_commands')) {
    <button class="ai-fab-mobile" [attr.aria-label]="ss.t('aria_aiAssistant')"
      (click)="onAiFabClick()"
      appLongPress (appLongPress)="onAiFabLongPress()">
      <app-svg name="meoSparkle" [color]="ss.theme().color12"
        style="width: 24px; height: 24px;">
      </app-svg>
    </button>
    }
  </div>

</div>
}
